export default "__VITE_ASSET__c96e8269__"